import { checkSession } from "@features/auth";
import { preloadQuery } from "@relay";
import { createFileRoute, redirect } from "@tanstack/react-router";
import type { sharedAccessPageQuery } from "../swap/__generated__/sharedAccessPageQuery.graphql";
import { query, SharedAccessPage } from "../swap/shared-access.$reservationId";

export const Route = createFileRoute("/$hubMetaName/lock/shared-access/$reservationId")({
	beforeLoad: () => {
		document.title = "bacehub | Lock";
	},
	component: RouteComponent,
	loader: async (ctx) => {
		if (!(await checkSession())) {
			throw redirect({
				to: "/auth",
				search: { redirectToPath: `/${ctx.params.hubMetaName}/lock${ctx.location.searchStr}` },
			});
		}
		return preloadQuery<sharedAccessPageQuery>(ctx.context.relayEnvironment, query, {
			hubName: ctx.params.hubMetaName,
			reservationId: ctx.params.reservationId,
		});
	},
});

function RouteComponent() {
	const { hubMetaName, reservationId } = Route.useParams();
	return <SharedAccessPage queryRef={Route.useLoaderData()} hubMetaName={hubMetaName} reservationId={reservationId} service="LOCK_B2C" />;
}
